const citeRegex = /<CITE>(.*?)<\/CITE>/g;

export const extractRefsFromSummary = (summary, referencedCitations) => {
  if (!summary || !referencedCitations) return {};

  const summaryRefs = [];
  let match = citeRegex.exec(summary);
  while (match !== null) {
    summaryRefs.push(match[1]);
    match = citeRegex.exec(summary);
  }

  const refsMap = referencedCitations.reduce((acc, citation, index) => {
    const cnr = citation?.id;
    if (summaryRefs.includes(cnr)) {
      acc[cnr] = index + 1; // 1-based index
    }
    return acc;
  }, {});

  return refsMap;
};

export function replaceRefsInSummaryWithIndexes(summary, referencedCitations) {
  if (!summary) return '';

  // Map {[cnr]: index}
  const refsFromSummary = extractRefsFromSummary(summary, referencedCitations);
  return summary.replace(citeRegex, (match, p1) => {
    const index = refsFromSummary[p1];
    return index ? `(${index})` : match;
  });
}
